// assets/cart.js

// 1) Ensure fetchConfig exists
if (typeof fetchConfig === "undefined") {
  window.fetchConfig = function (type = "json") {
    const config = {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    };
    if (type === "json") {
      config.headers["Content-Type"] = "application/json";
      config.headers["Accept"] = "application/json";
    }
    return config;
  };
}

// 2) The four section IDs we want to re-render
const CART_SECTIONS = [
  "cart-drawer",
  "cart-icon-bubble",
  "main-cart-items",
  "main-cart-footer",
];

// 3) updateSections: swap each container’s innerHTML
function updateSections(responseJson) {
  const sections = responseJson.sections || responseJson;
  CART_SECTIONS.forEach((id) => {
    const html = sections[id];
    if (!html) return;
    if(id == "cart-drawer") { //CD cart drawer update
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      if(doc.querySelector("cart-drawer").classList.contains('is-empty')) {
        document.querySelector("cart-drawer").classList.add('is-empty'); 
      } else {
        document.querySelector("cart-drawer").classList.remove('is-empty');
      }
      document.querySelector("cart-drawer .drawer__inner").innerHTML = doc.querySelector("cart-drawer .drawer__inner").innerHTML;
      return;
    }
    const container = document.getElementById(id);
    if (container) container.innerHTML = html;
  });
}

// 4) changeQuantity: POST to /cart/change.js then updateSections
async function changeQuantity(line, quantity) {
  const params = new URLSearchParams({
    line: line,
    quantity,
    sections: CART_SECTIONS.join(","),
    sections_url: routes.cart_url,
  });
  const resp = await fetch(
    // `${routes.cart_change_url}.js?${params.toString()}`,
    `${routes.cart_change_url}.js`,
    {
      ...fetchConfig(),
      body: JSON.stringify({ line: line, quantity, sections: CART_SECTIONS.join(",") }),
    }
  );
  if (!resp.ok) {
    if(resp.status == 422) {
      const error = await resp.json();    
      throw new Error(error.message); 
    }
    throw new Error("Quantity change failed"); 
  }
  const data = await resp.json();
  updateSections(data);
  return data;
}

// 5) addToCart: POST to /cart/add.js then updateSections
async function addToCart(formData) {
  const params = new URLSearchParams({
    sections: CART_SECTIONS.join(","),
    sections_url: routes.cart_url,
  });
  const resp = await fetch(
    `${routes.cart_add_url}.js?${params.toString()}`,
    {
      method: "POST",
      credentials: "same-origin",
      body: formData,
    }
  );
  if (!resp.ok) throw new Error("Add to cart failed");
  const data = await resp.json();
  updateSections(data);
  return data;
}

// 6) CartRemoveButton: calls changeQuantity(line, 0)
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", async (e) => {
      
      e.preventDefault();
      const line = this.dataset.index;
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.enableLoading?.(line);
      try {
        await changeQuantity(line, 0);
      } catch (err) {
        console.error("Remove failed:", err);
      } finally {
        cartItems.disableLoading?.();
      }
    });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);



// 7) CartItems: wire quantity buttons & inputs to changeQuantity
class CartItems extends HTMLElement {
  constructor() {
    super();
    this.statusEl =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    // Delegated click: plus/minus buttons
    
    // this.addEventListener("click", async (e) => {
    //   const btn = e.target.closest(".quantity__button");
    //   if (!btn) return;
    //   e.preventDefault();
    //   isProgrammaticQtyChange = true;
    //   const wrapper = btn.closest(".cart-item");
    //   const input = wrapper.querySelector(".quantity__input");
    //   let newQty =
    //     parseInt(input.value, 10) + (btn.name === "plus" ? 1 : -1);
    //   newQty = Math.max(0, newQty);
    //   input.value = newQty;

    //   const line = input.dataset.index;
    //   this.enableLoading(line);
      
    //   try {
    //     await changeQuantity(line, newQty);
    //   } catch (err) {
    //     console.error("Quantity change failed:", err);
    //     input.value = input.getAttribute("value");
    //   } finally {
    //     this.disableLoading();
    //   }
    // });

    // Delegated change: direct input edits (debounced)
    this.addEventListener(
      "change",
      debounce(async (e) => {
        if (!e.target.matches(".quantity__input")) return;
        let newQty = parseInt(e.target.value, 10) || 0;
        e.target.value = newQty;
        const line = e.target.dataset.index;
        this.enableLoading(line);
        try {
          await changeQuantity(line, newQty);
        } catch (err) {
          console.error("Quantity change failed:", err);
          e.target.value = e.target.getAttribute("value");
        } finally {
          this.disableLoading();
        }
      }, 300)
    );
  }

  enableLoading(line) {
    const container =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    container?.classList.add("cart__items--disabled");
    this.statusEl?.setAttribute("aria-hidden", "false");
  }

  disableLoading() {
    const container =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    container?.classList.remove("cart__items--disabled");
    this.statusEl?.setAttribute("aria-hidden", "true");
  }
}
customElements.define("cart-items", CartItems);

// 8) CartNote: updates note + re-renders sections
if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          "change",
          debounce(async (e) => {
            const note = e.target.value;
            const params = new URLSearchParams({
              note,
              sections: CART_SECTIONS.join(","),
              sections_url: routes.cart_url,
            });
            const resp = await fetch(
              `${routes.cart_update_url}.js?${params.toString()}`,
              { ...fetchConfig() }
            );
            const data = await resp.json();
            updateSections(data);
          }, 300)
        );
      }
    }
  );
}

// 9) product:added — calls addToCart & opens drawer
document.addEventListener("product:added", async (e) => {
  try {
    const form = e.target.closest("form[action^='/cart/add']");
    const formData = new FormData(form);
    await addToCart(formData);

    const drawer = document.querySelector("cart-drawer");
    if (drawer) {
      document.body.classList.add("overflow-hidden");
      drawer.classList.add("is-open");
    }
  } catch (err) {
    console.error("Add-to-cart failed:", err);
  }
});

//CD cart drawer refresh on add to cart by ecom
document.addEventListener("ec-cart-added", async () => {
  const params = new URLSearchParams({
    sections: CART_SECTIONS.join(","),
    sections_url: routes.cart_url,
  });
  const resp = await fetch(`${location.pathname}?${params.toString()}`,{
    method: "GET"
  });
  const data = await resp.json();
  updateSections(data);
  document.querySelector("cart-drawer").classList.add("active");
});

// expose for non-module scripts
window.changeQuantity = changeQuantity;
window.addToCart      = addToCart;

